import {
  HttpClient,
  HttpEvent,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class PolizaService {
  constructor(private http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/unidades/get`
    );
  }

  public getPolizas(id: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/recepcion/poliza/get`,
      { params: { id } }
    );
  }

  public add(datos: any, poliza: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("IdUnidad", String(datos.IdUnidad));
    formData.append("Vigencia", String(datos.Vigencia));
    if (poliza) {
      formData.append("poliza", poliza, "poliza");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/recepcion/poliza/add`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }

  public down(id: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${environment.serverUrl}api/settings/recepcion/poliza/down`,
      { params: { id }, responseType: "blob", observe: "response" }
    );
  }
}
